import { render, staticRenderFns } from "./SprintlyButton.vue?vue&type=template&id=4489c47f&scoped=true"
import script from "./SprintlyButton.vue?vue&type=script&lang=js"
export * from "./SprintlyButton.vue?vue&type=script&lang=js"
import style0 from "./SprintlyButton.vue?vue&type=style&index=0&id=4489c47f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4489c47f",
  null
  
)

export default component.exports